import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-state-sign-up-confirm',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lp2-private-class-banner-container>
      <lp2-private-class-center-header-banner>
        <div class="d-flex flex-1 flex-column">
          <p class="mt-2 mb-3 ml-sm-4 fw-bold fs-5 lh-4 bg-transparent text-center">
            {{ 'oeapp.studybundle.pc.confirmLesson.text' | translate }}
          </p>
          <lp2-private-class-lesson-detail-box
            [selectedLesson]="selectedLesson"
            [showTileEffect]="true"
          ></lp2-private-class-lesson-detail-box>
          <div class="d-flex flex-wrap justify-content-center">
            <button class="btn btn-accent-text fs-5 fw-bold mr-3" (click)="onCancel($event)">
              {{ 'cancelCaption' | translate }}
            </button>
            <span style="min-width: 150px">
              <ng-content></ng-content>
            </span>
          </div>
        </div>
      </lp2-private-class-center-header-banner>
    </lp2-private-class-banner-container>
  `,
})
export class PrivateClassStateSignUpConfirmComponent {
  @Input() selectedLesson: PrivateClassLesson;
  @Output() cancel = new EventEmitter();

  public onCancel(event: Event) {
    this.cancel.emit(event);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-sign-up-confirm.component.ts